import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  encapsulation: ViewEncapsulation.Native
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
